import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import TeamEventList from 'containers/TeamEventList';
import styled from 'styled-components';
import { Button } from '@shoflo/polymer/components/Button/Button';
import {
  getTeamEvents,
  startCreatingEvent,
  startDuplicatingEvent
} from 'actions/Event';

import Paths from 'AppPaths';
import { UPCOMING_EVENT_FILTERS } from 'constants/EventFilters';

import { matchPath } from 'react-router';
import { connect } from 'react-redux';
import Tooltip from 'components/Tooltip';

const StyledCreateEventButton = styled(Button)`
  min-width: 144px;

  @media only screen and (max-width: 576px) {
    display: none;
  }
`;

function Unconnected({
  startCreatingEvent,
  startDuplicatingEvent,
  getTeamEvents,
  teamEvents,
  teamId,
  team,
  user,
  isLoading
}) {
  useEffect(() => {
    getTeamEvents();
  }, [getTeamEvents, teamId, user]);

  const CreateEventButton = (
    <>
      <Tooltip
        id="team-dash-create-event-btn"
        title="Create a new file, Import data, or upload content"
      />
      <StyledCreateEventButton
        aria-describedby="tip-team-dash-create-event-btn"
        onClick={startCreatingEvent}
        color="primary"
        data-testid="create-event-button"
      >
        Create event
      </StyledCreateEventButton>
    </>
  );

  return (
    <TeamEventList
      filter={UPCOMING_EVENT_FILTERS}
      events={teamEvents}
      team={team}
      isLoading={isLoading}
      createEventButton={CreateEventButton}
      duplicateButtonAction={startDuplicatingEvent}
    />
  );
}

const PropMapper = ({ teamEvents, team, user, isEventLoading }, { match }) => {
  const teamMatch = matchPath(match.url, {
    path: Paths.TeamDash
  });

  const teamId = teamMatch ? teamMatch.params.teamId : null;

  return {
    team,
    teamEvents,
    teamId,
    user,
    isLoading: isEventLoading
  };
};

export default withRouter(
  connect(PropMapper, {
    startCreatingEvent,
    startDuplicatingEvent,
    getTeamEvents
  })(Unconnected)
);

export { Unconnected, PropMapper };
